var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup18171(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_18171",
    "data-name": "Grupo 18171",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.239,
    height: 13.017,
    viewBox: "0 0 13.239 13.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14010",
    "data-name": "Grupo 14010",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9976",
    "data-name": "Trazado 9976",
    d: "M5.224,3.694,5,2.96A5.407,5.407,0,0,0,1.169,7.6l-.615-.64L0,7.5,1.5,9.055,3.107,7.51l-.533-.555-.627.6A4.641,4.641,0,0,1,5.22,3.694",
    transform: "translate(0 -1.697)",
    fill: "#221c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9977",
    "data-name": "Trazado 9977",
    d: "M22.19,12.87l-1.5,1.558.555.533.576-.6a4.642,4.642,0,0,1-3.393,3.884l.226.734A5.416,5.416,0,0,0,22.6,14.33l.666.64.533-.555L22.194,12.87Z",
    transform: "translate(-10.564 -7.377)",
    fill: "#221c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9978",
    "data-name": "Trazado 9978",
    d: "M18.538,5.186l.738-.213a5.41,5.41,0,0,0-4.682-3.884l.546-.546L14.6,0,13.02,1.579l1.528,1.528.542-.542-.721-.721a4.646,4.646,0,0,1,4.17,3.342",
    transform: "translate(-7.463 0)",
    fill: "#221c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9979",
    "data-name": "Trazado 9979",
    d: "M7.931,20.289l-.542.542.653.653a4.645,4.645,0,0,1-4-3.384l-.738.213a5.413,5.413,0,0,0,4.729,3.944l-.593.593.542.542,1.528-1.528L7.926,20.285Z",
    transform: "translate(-1.892 -10.375)",
    fill: "#221c43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18171);
export default __webpack_public_path__ + "static/media/group18171.be765fcf519750bf6d70492dab59b14b.svg";
export { ForwardRef as ReactComponent };